<template>
    <div>
        <hts-form-button
            color="info"
            size="mini"
            class="float-right''"
            @click="handleOpen">
            Thêm số container
        </hts-form-button>
        <hts-modal
            :show="!!open"
            size="medium"
            title="Danh sách container"
            @close="open = false">
            <hts-form
                :rules="formData.rules[formData.data.type]"
                @submit="handleSubmit">
                <hts-form-radio
                    v-model="formData.data.type"
                    class="ml-5"
                    :items="timeConditionTimeTypes"
                    value-key="key"
                    label-key="label"
                    required />

                <UploadFileContainerNumber
                    v-if="formData.data.type === 'file'"
                    v-model="formData.data.fileContainerNumbers"
                    :file-name="formData.data.fileContainerNumbersName"
                    :file-url="formData.data.fileContainerNumbersUrl" />

                <div v-else>
                    <div
                        v-for="(item, index) in formData.data.containerNumbers"
                        :key="index"
                        class="mb-2 flex gap-2 items-center align-middle">
                        <hts-form-input
                            v-model="item.containerNumber"
                            required
                            class="w-full"
                            label="Số container" />

                        <hi-x-circle-icon
                            class="h-6 w-6 ml-2 mt-4 text-error-500 cursor-pointer"
                            @click="($event: any) => deleteContainerNumber($event, index)" />
                    </div>

                    <hts-form-button
                        class="mt-2"
                        color="info"
                        size="small"
                        @click="addContainerNumber">
                        Thêm số container
                    </hts-form-button>
                </div>

                <div class="flex justify-end mt-5">
                    <hts-form-button
                        icon-position="right"
                        type="button"
                        :outline="false"
                        @click="handleClose">
                        {{ $t('labels.close') }}
                    </hts-form-button>

                    <hts-form-button
                        :loading="!!loadingSubmit"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :outline="false">
                        {{ $t('labels.add') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
import UploadFileContainerNumber from '../component/container-numbers.vue'
const { $formatters } = useNuxtApp()

const props = defineProps({
  orderId: {
    type: String,
    require: true
  },
  orderCode: {
    type: String,
    require: true
  },
  type: {
    type: String,
    default: 'create'
  }
})
const emits = defineEmits(['update-allotment', 'update-container-numbers'])
const { orderId, orderCode } = toRefs(props)

const open = ref<Boolean>(false)
const loadingSubmit = ref<Boolean>(false)

const handleOpen = async () => {
  await getData(orderId?.value || '')
  open.value = true
}

const formData = ref<{ [key: string]: any }>({
  data: {
    type: 'file',
    fileContainerNumbers: '',
    fileContainerNumbersName: '',
    containerNumbers: [
      {
        _id: $formatters.generateId(),
        containerNumber: ''
      }
    ]
  },
  rules: {
    file: {
      // containerNumberFile: 'fileSize:10'
    },
    manual: {}
  }
})

const getData = async (orderId2: string) => {
  if (!orderId2) {
    return
  }

  const url = $url.order.order.getContainerNumbers

  const data: any = await $api(url, { uriParams: { ID: orderId2 } })
  const resData: any = data?.data?.value

  if (resData?.success && resData.data.typeInputContainerNumbers) {
    formData.value.data.type = resData.data.typeInputContainerNumbers
    if (formData.value.data.type === 'manual') {
      formData.value.data.containerNumbers = resData.data.containerNumbers
    } else {
      formData.value.data.fileContainerNumbersName = resData.data.fileContainerNumbers?.fileName || ''
      formData.value.data.fileContainerNumbersUrl = resData.data.fileContainerNumbers?.url || ''
      formData.value.data.containerNumbers = resData.data.containerNumbers
    }
  }

  if (!formData.value.data.containerNumbers?.length) {
    formData.value.data.containerNumbers = [
      {
        _id: $formatters.generateId(),
        containerNumber: ''
      }
    ]
  }
}

const addContainerNumber = () => {
  formData.value.data.containerNumbers.push({
    _id: $formatters.generateId(),
    containerNumber: ''
  })
}

const deleteContainerNumber = (e: Event, index: number) => {
  e.preventDefault()
  e.stopPropagation()

  if (index < 0 || index >= formData.value.data.containerNumbers.length) {
    return
  }

  if (formData.value.data.containerNumbers.length === 0) {
    formData.value.data.containerNumbers[0].containerNumber = ''
    return
  }
  formData.value.data.containerNumbers.splice(index, 1)
}

const handleSubmit = $lodash.debounce(async (options?: { [key: string]: any }) => {
  loadingSubmit.value = true

  if (!orderId?.value) {
    loadingSubmit.value = false
    return
  }

  const { type, fileContainerNumbers, containerNumbers } = formData.value.data

  if (type === 'file') {
    if (!fileContainerNumbers) {
      process.client && $toast().error('Vui lòng tải tệp số container')
      loadingSubmit.value = false
      return
    }
  }

  const body = new FormData()

  body.append('type', type)
  if (type === 'file') {
    body.append('fileContainerNumbers', fileContainerNumbers)
    body.append('containerNumbers', '')
  } else {
    body.append('fileContainerNumbers', '')
    body.append('containerNumbers', JSON.stringify(containerNumbers))
  }

  const url = $url.order.order.addContainerNumbers

  const data: any = await $api(url, { body, uriParams: { ID: orderId.value } })

  const resData: any = data?.data?.value

  if (resData?.success) {
    loadingSubmit.value = false
    emits('update-container-numbers', resData.data.containerNumbers)
    process.client && $toast().success('Thêm số container thành công')

    reset()
    handleClose()
  }

  loadingSubmit.value = false
}, 300)

const reset = () => {
  formData.value.data = {
    type: 'file',
    fileContainerNumbers: '',
    fileContainerNumbersName: '',
    containerNumbers: [
      {
        _id: $formatters.generateId(),
        containerNumber: ''
      }
    ]
  }
}

const handleClose = () => {
  open.value = false
}

const timeConditionTimeTypes = [
  {
    key: 'file',
    label: 'Tải tệp lên từ máy của bạn'
  },
  {
    key: 'manual',
    label: 'Nhập thủ công'
  }
]
</script>
